import { useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import ProductIndex from '../ProductQuestion/Product';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import ProductQuestionModal from '../../Modal/ProductQuestionModal';
import BundleErrorModal from '../../Modal/BundleErrorModal';
import Loader from '../../Loader/Loader';
import Employment from '../Employment/Employment';
import { ProductUIStyles } from './ProductUIStyles';
import { productMapping } from '../../../services/productMapping';
import EliteImage2 from '../../../images/EliteAccImg2.png';

import { productNameURLMapping } from '../../../services/productNameURLMapping';
import {
  COMPLIANCE_HEAD,
  COMPLIANCE_HEAD_PROG,
  COMPLIANCE_POLICY,
  ELITE_ACCOUNT_EN,
  LIBRE_AHORRA_BUNDLE,
  MODALTEXTHEADING,
  MODAL_PRODUCT_CONTENT,
  PRODUCT_KEY_TEXTONE,
  PRODUCT_KEY_TEXTTWO,
  REQUEST_FAIL,
  VOUCHED_ERROR,
} from '../../../constants';
import { CommonStyles } from '../CommonStyles';
import Layout from '../../Layout';
import RetailImage2 from '../../../images/Retail_Image_2.png';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import NewLayout from '../../Bundle/NewLayout';
import { commonTernary, isBundle, isCDIraproduct, isSimilarIRAProducts } from '../../commonCode';

/** ComplianceContent is the parent comp rendered on UI as a screen 4 for normal account opening process
 * Employment is its child comp
 */
function ComplianceContent(props) {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { disable, itemsHandler, isValidating, continueStep, history } = props;
  const {
    complianceItemsAnswer,
    setComplianceItemsAnswer,
    complianceData,
    productName,
    openProductQuestionModal,
    location,
    language,
    isModalSaveLater,
    setIsModalSaveLater,
  } = leadGenerationContext;
  const classes = CommonStyles(leadGenerationContext?.theme);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  /**
   * Handle back button: Should be navigated back to address information(screen 3) */
  const back = (e) => {
    e.preventDefault();
    history.push(
      `/${location?.toLowerCase()}/${language?.toLowerCase()}/retail-form/${productNameURLMapping(
        productName
      )}/address-info`
    );
  };

  /**
   * Handle Save Application button: Should be navigated to Save Application Page */
  const handleSaveApplication = (e) => {
    e.preventDefault();
    setIsModalSaveLater(true);
  };
  const complianceBundle = () => (
    <NewLayout
      ariaDescribedby="screenFourHeading"
      headingId="screenFourHeading"
      ariaDescribedbyId="screenFourDesc"
      classes={classes}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Compliance Page Text Prog'
          : 'Compliance Page Text'
      }
      descriptionValue={
        productMapping(productName) === 'Elite Account' ? COMPLIANCE_HEAD_PROG : COMPLIANCE_HEAD
      }
      stepValue={2}
      handleBack={back}
      handleContinue={continueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={disable || isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        isSimilarIRAProducts(productName)
          ? EliteImage2
          : RetailImage2
      }
    >
      <Box component="div" role="main" aria-describedby="screenFourHeading">
        {complianceData?.questions && complianceData.questions.length > 0 ? (
          <>
            <div>
              {complianceData.questions.map((item) => (
                <Grid container key={item?.name}>
                  <ProductIndex
                    item={item}
                    disable={disable}
                    setItemsAnswer={setComplianceItemsAnswer}
                    itemsHandler={itemsHandler}
                    itemsAnswer={complianceItemsAnswer}
                    productData={complianceData}
                    currentPage={leadGenerationContext.currentPage}
                    productName={leadGenerationContext.productName}
                    isBundleCompliance
                  />
                </Grid>
              ))}
            </div>
            <Box component="div" role="application" sx={styledClasses.questionContainerEmpBundle}>
              <Employment isBundleCompliance />
            </Box>
          </>
        ) : (
          <div className="consent-loader-style">
            <Loader />
          </div>
        )}
        {isModalSaveLater && (
          <SaveAppContactInfo openModal={isModalSaveLater} currentPage="compliance-info" />
        )}
      </Box>
    </NewLayout>
  );

  const compliance = () => (
    <Layout
      ariaDescribedby="screenFourHeading"
      headingId="screenFourHeading"
      ariaDescribedbyId="screenFourDesc"
      classes={classes}
      descriptionKey={
        productMapping(productName) === 'Elite Account'
          ? 'Compliance Page Text Prog'
          : 'Compliance Page Text'
      }
      descriptionValue={
        productMapping(productName) === 'Elite Account' ? COMPLIANCE_HEAD_PROG : COMPLIANCE_HEAD
      }
      stepValue={2}
      handleBack={back}
      handleContinue={continueStep}
      handleSaveApplication={handleSaveApplication}
      disableCondition={disable || isValidating}
      backBtnTestid="backBtn_id"
      continueBtnTestid="continueBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        isSimilarIRAProducts(productName)
          ? EliteImage2
          : RetailImage2
      }
    >
      <Box
        component="div"
        role="main"
        aria-describedby="screenFourHeading"
        sx={styledClasses.product_grid}
      >
        {complianceData?.questions && complianceData.questions.length > 0 ? (
          <>
            <div>
              {complianceData.questions.map((item) => (
                <Grid container key={item?.name}>
                  <ProductIndex
                    item={item}
                    disable={disable}
                    setItemsAnswer={setComplianceItemsAnswer}
                    itemsHandler={itemsHandler}
                    itemsAnswer={complianceItemsAnswer}
                    productData={complianceData}
                    currentPage={leadGenerationContext.currentPage}
                  />
                </Grid>
              ))}
            </div>
            <Box component="div" role="application" sx={styledClasses.questionContainerEmp}>
              <Employment />
            </Box>
          </>
        ) : (
          <div className="consent-loader-style">
            <Loader />
          </div>
        )}
        {isModalSaveLater && (
          <SaveAppContactInfo openModal={isModalSaveLater} currentPage="compliance-info" />
        )}
      </Box>
    </Layout>
  );

  const complianceJSX = commonTernary(isBundle(productName), complianceBundle(), compliance());

  return (
    <>
      {complianceJSX}

      <ProductQuestionModal
        openModal={openProductQuestionModal && !isBundle(productName)}
        message={{
          messageKeyOne: PRODUCT_KEY_TEXTONE,
          messageOne: MODALTEXTHEADING,
          messageKeyTwo: PRODUCT_KEY_TEXTTWO,
          messageTwo: MODAL_PRODUCT_CONTENT,
        }}
      />
      <BundleErrorModal
        openModal={openProductQuestionModal && isBundle(productName)}
        message={{
          errorHead: VOUCHED_ERROR,
          errorTitle: REQUEST_FAIL,
          errorDescription: COMPLIANCE_POLICY,
        }}
      />
    </>
  );
}

export default withRouter(ComplianceContent);

ComplianceContent.propTypes = {
  disable: PropTypes.bool,
  itemsHandler: PropTypes.func,
  isValidating: PropTypes.bool,
  continueStep: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
